"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
exports.__esModule = true;
exports.InstalledAppsDocument = exports.Integration = exports.MarketplaceAppType = exports.MarketplaceAppPricingModel = exports.MarketplaceAppDocument = void 0;
var marketplace_app_document_1 = require("./marketplace-app-document");
__createBinding(exports, marketplace_app_document_1, "MarketplaceAppDocument");
__createBinding(exports, marketplace_app_document_1, "MarketplaceAppPricingModel");
__createBinding(exports, marketplace_app_document_1, "MarketplaceAppType");
__createBinding(exports, marketplace_app_document_1, "Integration");
var installed_apps_document_1 = require("./installed-apps-document");
__createBinding(exports, installed_apps_document_1, "InstalledAppsDocument");
